import { gql } from "@apollo/client"
import { InjectedOptions, useMutation } from "@oysterhr/core"
import { CreateCustomerBankAccountInput, CreateCustomerBankAccountPayload } from "@oysterhr/schema"

const COMPANY_CREATE_CUSTOMER_BANK_ACCOUNT = gql`
  mutation CompanyCreateCustomerBankAccount(
    $ownerId: ID!
    $bankDetails: PaymentMethodsCustomerBankAccountDetailsInput!
    $billingAddress: AddressArguments
    $paymentMethodType: PaymentMethodsCustomerBankAccountEnumType!
    $userNotSigner: Boolean
    $bankAccountType: BankAccountEnumType
  ) {
    createCustomerBankAccount(
      input: {
        ownerId: $ownerId
        bankDetails: $bankDetails
        paymentMethodType: $paymentMethodType
        billingAddress: $billingAddress
        userNotSigner: $userNotSigner
        bankAccountType: $bankAccountType
      }
    ) {
      customerBankAccount {
        ... on PaymentMethodsCustomerBankAccountSepaType {
          id
          accountHolderName
          accountNumber
        }
        ... on PaymentMethodsCustomerBankAccountAchType {
          id
          accountHolderName
          accountNumber
        }
      }
      errors
    }
  }
`

export const useCreateCustomerBankAccount = (
  options?: InjectedOptions<
    { createCustomerBankAccount: CreateCustomerBankAccountPayload },
    CreateCustomerBankAccountInput
  >,
) => useMutation(COMPANY_CREATE_CUSTOMER_BANK_ACCOUNT, options)
